import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';
import { createCookie, readCookie } from '../../common/Cookie';

class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      showApp: false,
      tickerClosed: false
    };
    this.hideApp = this.hideApp.bind(this);
  }

  componentDidMount() {
    let { apptickerwcms: { viewAllUrlLink = '' } = {} } = this.props;

    let marketingObj = {};
    let marketingCookie = readCookie('cdigiMrkt') || '';
    let marketingCookieSplit = marketingCookie.split('|');

    for (let i = 0; i < marketingCookieSplit.length; i++) {
      let eachValueSplit = marketingCookieSplit[i].split(':');
      marketingObj[eachValueSplit[0]] = eachValueSplit[1];
    }

    let utmparams = `&utm_campaign=MSITE_direct`;
    if (marketingObj && marketingObj.utm_campaign) {
      let campaign_value = marketingObj.utm_campaign;
      utmparams = `&utm_campaign=MSITE_${campaign_value}`;
    }

    // let __utmz;
    // let utmparams = '';
    // //createCookie('__utmz', '43838368.1523974267.1.1.utmcsr=(direct)|utmccn=(direct)|utmcmd=(none)', 730);
    // __utmz = readCookie('__utmz');

    // if(__utmz && __utmz !== '') {
    //   const srcarr = __utmz.split('.');
    //   const utmarr = srcarr.length > 0 ? (srcarr[srcarr.length -1].split('|')) : [];
    //   var regExp = /\(([^)]+)\)/;
    //   var matches = utmarr.length > 1 ? regExp.exec(utmarr[1].split("=")[1]) : [];
    //   let campaign_value = matches.length > 1 ? matches[1] : utmarr.length > 1 ? utmarr[1].split("=")[1] : 'direct';
    //     utmparams = `utm_campaign=MSITE_${campaign_value}`;
    // } else {
    //   utmparams = `utm_campaign=MSITE_direct`;
    // }

    if (
      navigator.userAgent.toUpperCase().indexOf('ANDROID') > -1 ||
      navigator.userAgent.toUpperCase().indexOf('IPAD') > -1 ||
      navigator.userAgent.toUpperCase().indexOf('IPHONE') > -1
    ) {
      var link_af_dp = `${properties.getProperty('siteUrl') +
        window.location.pathname}?${utmparams}`;
      link_af_dp = encodeURIComponent(link_af_dp);
      // var deepLinkUrl = `https://ajioapps.onelink.me/1622090911/mt?af_dp=${link_af_dp}&af_web_dp=${link_af_dp}`;
      var deepLinkUrl = viewAllUrlLink ? `${viewAllUrlLink}` : this.getDeepLinkUrl();
      // console.log('app ticker ',deepLinkUrl);
      document.getElementById('appAnchor').href = deepLinkUrl;
      document.querySelector('.app-installbtn').classList.remove('app-installbtn-app');
    } else {
      var staticPath = 'javascript:void(0)';
      window.onload = () => {
        document.getElementById('appAnchor').href = staticPath;
        document.querySelector('.app-installbtn').classList.remove('app-installbtn-app');
      };
    }

    // if (navigator.userAgent.toUpperCase().indexOf("IPAD") > -1 || navigator.userAgent.toUpperCase().indexOf("IPHONE") > -1) {
    //     var ituneLink = "https://itunes.apple.com/in/app/ajio-online-shopping-app/id1113425372?rutm_campaign=Organic_App_Install&utm_source=App_Microsite_Mobile&utm_medium=App_Store_Badge";
    //     document.getElementById("appAnchor").href = ituneLink;
    //     document.querySelector(".app-installbtn").classList.add("app-installbtn-app");
    // }
    // else if (navigator.userAgent.toUpperCase().indexOf("ANDROID") > -1) {
    //   var andriodLink = "https://play.google.com/store/apps/details?id=com.ril.ajio&referrer=utm_source%3DApp_Microsite_Mobile%26utm_medium%3DPlay_Store_Badge%26utm_campaign%3DOrganic_App_Install";
    //   document.getElementById("appAnchor").href = andriodLink;
    //   document.querySelector(".app-installbtn").classList.remove("app-installbtn-app");
    // }
    // else{
    //   var staticPath = "javascript:void(0)"
    //   document.getElementById("appAnchor").href = staticPath;
    //   document.querySelector(".app-installbtn").classList.remove("app-installbtn-app");
    // }
  }

  getDeepLinkUrl() {
    let deepLinkUrl;
    if (
      navigator.userAgent.toUpperCase().indexOf('IPAD') > -1 ||
      navigator.userAgent.toUpperCase().indexOf('IPHONE') > -1
    ) {
      deepLinkUrl =
        'https://itunes.apple.com/in/app/ajio-online-shopping-app/id1113425372?rutm_campaign=Organic_App_Install&utm_source=App_Microsite_Mobile&utm_medium=App_Store_Badge';
    } else if (navigator.userAgent.toUpperCase().indexOf('ANDROID') > -1) {
      deepLinkUrl =
        'https://play.google.com/store/apps/details?id=com.ril.ajio&referrer=utm_source%3DApp_Microsite_Mobile%26utm_medium%3DPlay_Store_Badge%26utm_campaign%3DOrganic_App_Install';
    } else {
      deepLinkUrl = '#';
    }
    return deepLinkUrl;
  }

  hideApp() {
    this.setState({ showApp: false, tickerClosed: true });
    if (document.querySelector('.banner-components')) {
      document.querySelector('.banner-components').style.paddingTop = '87px';
      document.querySelector('.app-header').style.marginTop = '0px';
      document.querySelector('.search-block').style.top = '47px';
    }
    if (document.querySelector('.page--category')) {
      document.querySelector('.page--category').style.paddingTop = '60px';
      document.querySelector('.app-header').style.marginTop = '0px';
    }
    if (document.querySelector('.product-view')) {
      document.querySelector('.product-view').style.paddingTop = '47px';
      document.querySelector('.app-header').style.marginTop = '0px';
    }
    document.querySelector('.search-container').style.top = '0px';
    if (document.querySelector('.app-header')) {
      document.querySelector('.app-header').style.marginTop = '0px';
    }
    if (document.querySelector('.order-details-contents')) {
      document.querySelector('.order-details-contents').style.paddingTop = '47px';
    }
    if (window.sessionStorage) {
      window.sessionStorage.setItem('at', true);
    }
  }

  render() {
    let {
      apptickerwcms: {
        title = 'Ajio Online Shopping App',
        subText = 'Use App for a better experience',
        viewAllName = 'VIEW'
      } = {}
    } = this.props;
    // var appShow = this.state.showApp ? '' : 'close-app';
    let appShow = this.props.showAppTicker && !this.state.tickerClosed ? 'close-app' : 'close-app';

    return (
      <div>
        <div className={`apppanel-container ${appShow}`}>
          <div className="ic-app-closebtn" onClick={this.hideApp} />
          <div className="ic-app-logo" />
          <div className="app-text">
            <span>{title}</span>
            <span>{subText}</span>
          </div>
          <a target="_blank" id="appAnchor" href="">
            <div className="app-installbtn">{viewAllName}</div>
          </a>
        </div>
      </div>
    );
  }
}

let mapStateToProps = function({ appticker: apptickerwcms }) {
  return {
    apptickerwcms
  };
};

export default connect(mapStateToProps, null)(Layout);
